// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"e61b1775","379":"52605593"}[chunkId] + ".chunk.js";
};